import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import { App } from './App';
import './styles.css';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: String(import.meta.env.VITE_SENTRY_DSN),
    environment: String(import.meta.env.VITE_ENVIRONMENT ?? 'development'),
    sendDefaultPii: false,
  });
}
const client = new QueryClient({ defaultOptions: { queries: { staleTime: 10_000, retry: 1 } } });
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
